function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { IntlProvider } from "@amazeelabs/react-intl";
import { FrameQuery, Operation } from "@custom/schema";
import { APIProvider } from "@vis.gl/react-google-maps";
import React from "react";
import translationSources from "../../../build/translatables.json";
import { useLocale } from "../../utils/locale";
import { TranslationsProvider } from "../../utils/translations";
import { PageTransitionWrapper } from "../Molecules/PageTransition";
import { SkipLinks } from "../Molecules/SkipLinks";
import { SearchBarProvider } from "../Organisms/CampsiteSearch/SearchBarContext";
import { Footer } from "../Organisms/Footer";
import { Header } from "../Organisms/Header";
var TCS_GOOGLE_MAPS_API_KEY = "AIzaSyA0CRtpljUM-R6Yrm3fFSX0DDk3f-VGrjw";
function filterByLocale(locale) {
    return function(str) {
        return str.language === locale;
    };
}
function translationsMap(translatables) {
    return Object.fromEntries(// Make sure that Drupal translations have higher precedence.
    _to_consumable_array((translatables === null || translatables === void 0 ? void 0 : translatables.filter(function(tr) {
        return tr.__typename === "DecapTranslatableString";
    })) || []).concat(_to_consumable_array((translatables === null || translatables === void 0 ? void 0 : translatables.filter(function(tr) {
        return tr.__typename === "DrupalTranslatableString";
    })) || [])).filter(function(tr) {
        return tr.translation;
    }).map(function(tr) {
        return [
            tr.source,
            tr.translation
        ];
    }));
}
export function Frame(param) {
    var children = param.children;
    var locale = useLocale();
    return /*#__PURE__*/ React.createElement(Operation, {
        id: FrameQuery
    }, function(result) {
        if (result.state === "success") {
            var rawTranslations = result.data.stringTranslations || [];
            var translations = _object_spread({}, translationsMap((rawTranslations === null || rawTranslations === void 0 ? void 0 : rawTranslations.filter(filterByLocale("en"))) || []), translationsMap((rawTranslations === null || rawTranslations === void 0 ? void 0 : rawTranslations.filter(filterByLocale(locale))) || []));
            var messages = Object.fromEntries(Object.keys(translationSources).map(function(key) {
                return [
                    key,
                    translations[translationSources[key].defaultMessage] || translationSources[key].defaultMessage
                ];
            }));
            return /*#__PURE__*/ React.createElement(SearchBarProvider, null, /*#__PURE__*/ React.createElement(APIProvider, {
                apiKey: TCS_GOOGLE_MAPS_API_KEY,
                libraries: [
                    "marker"
                ]
            }, /*#__PURE__*/ React.createElement(IntlProvider, {
                locale: locale,
                messages: messages
            }, /*#__PURE__*/ React.createElement(TranslationsProvider, null, /*#__PURE__*/ React.createElement(SkipLinks, null), /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement(PageTransitionWrapper, null, children), /*#__PURE__*/ React.createElement(Footer, null)))));
        }
    });
}
